import Subtitle from "../Subtitle";
import Radio from "../Radio";
import Skeleton from "react-loading-skeleton";
import {COURSE_TYPES, LOCATIONS, useEventContext} from "../../contexts/EventContext";
import Icon from "../icons";
import {Label, LabelWrapper, Tooltip} from "../fields";
import AvailableStartDates from "../fields/AvailableStartDates";
import {cloneElement} from "preact";
import {useEffect, useState} from "preact/hooks";
import {format, addDays, subtractDays} from "../../utils/Date";
import {Field} from "../index";
import AttendeesForm from "./AttendeesForm";
import Money from "../../utils/Money";
import PropTypes from "prop-types";

const Event = ({ children }) => {
    const { event, selectedPeriod, selectedStartDate } = useEventContext();
    debugger;
    const copyChildren = children.map((child) => {
        return cloneElement(child, {
            event,
            selectedPeriod,
            selectedStartDate,
            ...child.props,
        })
    })
    return (
        <>{copyChildren}</>
    );
}

const Title = () => {
    const { event } = useEventContext();
    return <Subtitle text={event.name} />
}

const Total = () => {
    const { total } = useEventContext();
    const Component = ({ children }) => (
        <div className="esc-ii-flex esc-ii-items-center esc-ii-justify-between esc-ii-mt-6">
            <p className="esc-ii-uppercase esc-ii-font-bold esc-ii-text-sm">Total Fee</p>
            {children}
        </div>
    );
    return (
        <Component>
            <p className="esc-ii-font-montserrat esc-ii-font-semibold esc-ii-text-xl esc-ii-text-[22px]">
                {Money(total)}
            </p>
        </Component>
    );
}

const Summary = () => {
    const { attendees, selectedPeriod, selectedPeriodOption, selectedPeriodOptionAddOns, selectedStartDate,selectedFeatures } = useEventContext();

    let AddOns = () => (
        <p className="esc-ii-font-montserrat esc-ii-text-[13px]">Please select from available dates</p>
    );
    let accommodationDates;
    if (selectedPeriodOptionAddOns && Array.isArray(selectedPeriodOptionAddOns)) {
        accommodationDates = selectedPeriodOptionAddOns.find(element => element.addon.name.includes('Accommodation'));
        AddOns = () => (
            <ul>
                {selectedPeriodOptionAddOns.map(unique_addon => (
                    <li><p className={`esc-ii-font-montserrat esc-ii-text-[13px]`}>{unique_addon.addon.name}</p> </li>
                ))}
            </ul>
        )
    }

    let programmeDates = selectedStartDate && format(selectedStartDate);

    if (selectedPeriodOption && selectedPeriodOption.start_date && selectedPeriodOption.end_date) {
        programmeDates = `${format(selectedPeriodOption.start_date, 'Do MMMM')} - ${format(selectedPeriodOption.end_date)}`;
    }

    return (
        <>
            <header className="esc-ii-flex esc-ii-items-center esc-ii-justify-between esc-ii-my-5">
                <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-geometos esc-ii-text-xl">
                    Summary
                </h6>
            </header>
            <div className="esc-ii-flex esc-ii-flex-col esc-ii-mb-5">
                <div className="esc-ii-flex esc-ii-justify-between esc-ii-mb-4">
                    <div className="esc-ii-flex esc-ii-flex-col esc-ii-w-1/2">
                        <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-xs">Course Type</h6>
                        <p className="esc-ii-font-montserrat esc-ii-text-[13px]">{selectedPeriod ? selectedPeriod.location : `Please make a selection`}</p>
                    </div>
                    <div className="esc-ii-flex esc-ii-flex-col esc-ii-w-1/2">
                        <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-xs">Your Programme Dates</h6>
                        <p className="esc-ii-font-montserrat esc-ii-text-[13px]">{programmeDates || `Please select from available dates`}</p>
                    </div>
                </div>
                <div className="esc-ii-flex esc-ii-justify-between">
                    <div className="esc-ii-flex esc-ii-flex-col esc-ii-w-1/2">
                        <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-xs">Add-Ons</h6>
                        <AddOns />
                    </div>
                    <div className="esc-ii-flex esc-ii-flex-col esc-ii-w-1/2">
                        <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-xs">Your Accommodation Dates</h6>
                        {accommodationDates?(
                            <p className="esc-ii-font-montserrat esc-ii-text-[13px]">{`${subtractDays(selectedPeriodOption.start_date,1, 'Do MMMM')} - ${addDays(selectedPeriodOption.end_date,1)}`}</p>
                        ):(
                            <p className="esc-ii-font-montserrat esc-ii-text-[13px]">No Accommodation</p>
                        )}
                    </div>

                </div>
            </div>
            {
                attendees.length > 0 && (
                    <>
                        <hr className="esc-ii-text-charcoal esc-ii-mb-6" />
                        <ul className="esc-ii-flex esc-ii-flex-col esc-ii-space-y-5">
                            {attendees.map((attendee, index) => (
                                <li className={`esc-ii-flex esc-ii-flex-col${index > 0 ? ' esc-ii-mt-6' : ''}`}>
                                    <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-xs">
                                        Attendee #{index + 1}
                                    </h6>
                                    <h4 className="esc-ii-no-underline esc-ii-font-montserrat esc-ii-text-base esc-ii-mt-2">
                                        {attendee.first_name !== '' || attendee.last_name !== '' ? (
                                            `${attendee.first_name} ${attendee.last_name}`
                                        ) : (
                                            <span className="esc-ii-opacity-0">First/last name placeholder</span>
                                        )}
                                    </h4>
                                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-mt-1.5">
                                        {attendee.email !== '' ? (
                                            `${attendee.email}`
                                        ) : (
                                            <span className="esc-ii-opacity-0">Email placeholder</span>
                                        )}
                                    </p>
                                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-mt-1.5">
                                        {attendee.school.label !== '' ? (
                                            `${attendee.school.label}`
                                        ) : (
                                            <span className="esc-ii-opacity-0">School placeholder</span>
                                        )}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </>
                )
            }
        </>
    );
}

const Fixed = ({ navBar, modalRef }) => {

    const { event, attendees, attendeeQty, selectedPeriod, selectedPeriodOption, selectedPeriodOptionAddOns, total } = useEventContext();

    const navbarEle = document.querySelector(navBar);
    let defaultHeight = '100%';
    // if (navbarEle) {
    //     defaultHeight = `calc(100% - ${navbarEle.getBoundingClientRect().bottom}px)`;
    // }

    const [isOpen, setIsOpen] = useState(false);
    const [height, setHeight] = useState(defaultHeight);
    const [modalTop, setModalTop] = useState(null);

    const calcHeight = () => {
        // const spotTimer = document.getElementById('esc-ii-spot-timer');
        // let position = null;
        //
        // if (spotTimer) {
        //     const spotTimerBottom = spotTimer.getBoundingClientRect().bottom;
        //     const spotTimerMarginBottom = parseInt(getComputedStyle(spotTimer).marginBottom);
        //     const spotTimerActualHeight = spotTimer.getBoundingClientRect().height + spotTimerMarginBottom;
        //     if (spotTimerBottom > spotTimerActualHeight) {
        //         position = (spotTimerBottom + window.scrollY) - spotTimerMarginBottom;
        //         if (position)
        //             defaultHeight = `calc(100% - ${position}px)`;
        //     }
        // }

        return defaultHeight;
    }

    useEffect(() => {
        setModalTop(modalRef.current.style.top);
    }, []);

    useEffect(() => {

        if (isOpen) {
            setHeight(calcHeight());
            setModalTop(modalRef.current.style.top);
            modalRef.current.style.top = '0px';
        } else {
            setHeight('0');
            modalRef.current.style.top = modalTop;
        }

    }, [isOpen]);

    return (
        <>
            <div className="esc-ii-fixed esc-ii-transition-[height] esc-ii-ease-in-out esc-ii-duration-300 esc-ii-bottom-0 esc-ii-left-0 esc-ii-w-full esc-ii-bg-white esc-ii-z-30 lg:esc-ii-hidden esc-ii-flex esc-ii-flex-col esc-ii-justify-between"
                 style={{ height }}
            >
                <div className="esc-ii-flex esc-ii-flex-col">
                    <header className="esc-ii-flex esc-ii-items-center esc-ii-justify-between esc-ii-my-5 esc-ii-px-3">
                        <h3 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-geometos esc-ii-text-xl">
                            Summary
                        </h3>
                        <button
                            type="button"
                            className="esc-ii-flex esc-ii-items-center"
                            onClick={() => setIsOpen(false)}
                        >
                            <span className="esc-ii-uppercase esc-ii-font-extrabold esc-ii-font-geometos esc-ii-text-[10px] esc-ii-text-primary esc-ii-mr-2">Close</span>
                            <Icon.Chevron width="12" height="6" className="esc-ii-rotate-180 -esc-ii-mt-1" />
                        </button>
                    </header>

                    <div
                        className="esc-ii-overflow-auto esc-ii-px-3"
                    >
                        {/* Summary Line Items */}
                        <ul className="esc-ii-flex esc-ii-flex-col esc-ii-space-y-3 esc-ii-flex-auto">
                            {/* Summary Line Item */}
                            <li className="esc-ii-flex esc-ii-flex-col">
                                <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-font-bold esc-ii-text-[10px]">
                                    Dates
                                </h6>
                                <p className="esc-ii-font-montserrat esc-ii-text-xs esc-ii-mt-2">
                                    {Object.keys(selectedPeriod).length !== 0 ? selectedPeriod.date_range : (
                                        <Skeleton />
                                    )}
                                </p>
                            </li>

                            {/* Summary Line Item */}
                            <li className="esc-ii-flex esc-ii-flex-col">
                                <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-font-bold esc-ii-text-[10px]">
                                    Length Of Programme
                                </h6>
                                <p className="esc-ii-font-montserrat esc-ii-text-xs esc-ii-mt-2">
                                    {Object.keys(event).length === 0 ? (
                                        <Skeleton />
                                    ) : (
                                        selectedPeriodOption
                                        && Object.keys(selectedPeriodOption).length !== 0
                                            ? selectedPeriodOption.option_name :
                                            'Please select from available length'
                                    )}
                                </p>
                            </li>

                            {/* Summary Line Item */}
                            <li className="esc-ii-flex esc-ii-flex-col">
                                <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-font-bold esc-ii-text-[10px]">
                                    Optional Add-Ons
                                </h6>
                                <p className="esc-ii-font-montserrat esc-ii-text-xs esc-ii-mt-2" dangerouslySetInnerHTML={{ __html: selectedPeriodOptionAddOns
                                    && selectedPeriodOptionAddOns.length !== 0
                                        ? selectedPeriodOptionAddOns.map(addon => addon.addon.name).join('<br/>') : '' }}>
                                    {Object.keys(event).length === 0 && <Skeleton />}
                                </p>
                            </li>
                        </ul>

                        {/* Quantity Line Item */}
                        <div className="esc-ii-flex esc-ii-items-center esc-ii-justify-between esc-ii-my-4">
                            <span className="esc-ii-h-px esc-ii-flex-auto esc-ii-bg-charcoal/40 esc-ii-block esc-ii-mr-3"></span>
                            <small className="esc-ii-font-montserrat esc-ii-text-[10px]">
                                <strong className="esc-ii-uppercase esc-ii-text-black">
                                    Quantity <span>{attendeeQty}</span>
                                </strong>
                            </small>
                        </div>

                        {/* Attendee Line Item */}
                        {attendees.length > 0 && (
                            <ul className="esc-ii-flex esc-ii-flex-col esc-ii-space-y-5">
                                {attendees.map((attendee, index) => (
                                    attendee.first_name !== '' && attendee.last_name
                                    && attendee.email !== '' && attendee.school.label !== ''
                                        ? (
                                            <li className="esc-ii-flex esc-ii-flex-col">
                                                <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-[10px] esc-ii-mt-5 esc-ii-mb-3">
                                                    Attendee #{index + 1}
                                                </h6>
                                                <h4 className="esc-ii-no-underline esc-ii-font-montserrat esc-ii-mb-2 esc-ii-text-lg">
                                                    {`${attendee.first_name} ${attendee.last_name}`}
                                                </h4>
                                                <p className="esc-ii-font-montserrat esc-ii-mb-1 esc-ii-text-xs">{attendee.email}</p>
                                                <p className="esc-ii-font-montserrat esc-ii-mb-1 esc-ii-text-xs">{attendee.school.label}</p>
                                            </li>
                                        ) : (
                                            <li className="esc-ii-flex esc-ii-flex-col">
                                                <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-[10px] esc-ii-mt-5 esc-ii-mb-3">
                                                    Attendee #{index + 1}
                                                </h6>
                                                <p className="esc-ii-font-montserrat esc-ii-mb-1 esc-ii-text-xs">
                                                    Please complete the form
                                                </p>
                                            </li>
                                        )
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {/* Totals Line Item */}
                <div style={{ boxShadow: '0px -17px 24px rgba(0, 0, 0, 0.04)' }}
                     className="esc-ii-flex esc-ii-items-center esc-ii-justify-between esc-ii-py-7 esc-ii-px-5 esc-ii-mb-4">
                    <p className="esc-ii-uppercase esc-ii-font-montserrat esc-ii-text-sm">Total Fee</p>
                    <p className="esc-ii-font-montserrat esc-ii-text-base">
                        <strong>{Money(total)}</strong>
                    </p>
                </div>
            </div>

            <div className="esc-ii-fixed esc-ii-bottom-0 esc-ii-left-0 esc-ii-w-full esc-ii-bg-white esc-ii-z-20 lg:esc-ii-hidden esc-ii-flex">
                <button
                    type="button"
                    className="esc-ii-bg-yellow esc-ii-p-7 esc-ii-flex esc-ii-items-center"
                    onClick={() => setIsOpen(true)}
                >
                    <h6 className="esc-ii-no-underline esc-ii-uppercase esc-ii-font-bold esc-ii-mr-2 esc-ii-font-montserrat esc-ii-text-xs">
                        Check Summary
                    </h6>
                    <Icon.Chevron width={`12`} height={`6`} />
                </button>
                <div className="esc-ii-flex esc-ii-flex-col esc-ii-justify-center esc-ii-items-center esc-ii-text-center esc-ii-flex-auto">
                    <p className="esc-ii-uppercase esc-ii-font-montserrat esc-ii-text-xs">Total Fee</p>
                    <small className="esc-ii-text-black esc-ii-font-semibold esc-ii-font-montserrat esc-ii-text-xs">{Money(total)}</small>
                </div>
            </div>
        </>
    );
}
const OptionalAddOns = () => {
    const { selectedPeriodOption, upsertSelectedPeriodOptionAddOns, selectedPeriodOptionAddOns, isLoading } = useEventContext();

    const Component = ({ children }) => (
        <>
            <LabelWrapper>
                <Label>Optional Add-Ons</Label>
                <Tooltip>
                    <Subtitle text={`Optional Add-Ons`} />
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-mt-3 lg:esc-ii-text-base">
                        We offer private accommodation at University of London halls of residence, with meals and 24/7 guardianship included. If you choose accommodation, your check-in will be the day before your programme start date and your check-out will be the day after.<br/>
                    </p>
                </Tooltip>
            </LabelWrapper>
            <div className="esc-ii-flex esc-ii-flex-col esc-ii-space-y-2.5">
                {children}
            </div>
        </>
    );
    const SkeletonComponent = () => (
        <div className="esc-ii-flex">
            <Skeleton count={3} />
        </div>
    )

    if (isLoading) {
        return <Component><SkeletonComponent /></Component>
    }

    if (! selectedPeriodOption || ! Array.isArray(selectedPeriodOption.assigned_addons_unique)) {
        return <></>
    }

    const addons = selectedPeriodOption.assigned_addons_unique;

    if (addons.length === 0) {
        return <></>
    }

    const AddOnsComponent = () => addons.map(assigned_addon => {
        let selectedPeriodOptionAddOn = selectedPeriodOptionAddOns.find(
            addon => addon.event_period_addon_id === assigned_addon.event_period_addon_id
        );

        let disabled = parseInt(assigned_addon.assigned_addon_quantity_available) <= 0;

        if (disabled && selectedPeriodOptionAddOn) {
            upsertSelectedPeriodOptionAddOns(assigned_addon);
            selectedPeriodOptionAddOn = null;
        }

        return selectedPeriodOptionAddOn ? (
            <div className="esc-ii-flex">
                <button
                    type="button"
                    className={`esc-ii-w-12 esc-ii-h-12 esc-ii-rounded esc-ii-border-2 esc-ii-border-primary esc-ii-flex esc-ii-justify-center esc-ii-items-center`}
                    onClick={() => upsertSelectedPeriodOptionAddOns(assigned_addon)}
                >
                    <Icon.Tick className={`esc-ii-h-4 esc-ii-w-4`} />
                </button>
                <div className="esc-ii-flex esc-ii-flex-col esc-ii-ml-2.5">
                    <p className={`esc-ii-font-montserrat esc-ii-text-sm`}>
                        <strong>Add {selectedPeriodOptionAddOn.addon.name}</strong>
                    </p>
                    {selectedPeriodOptionAddOn.addon.name.includes('Accommodation')?(
                        <p className={`esc-ii-font-montserrat esc-ii-text-sm`}>
                            <strong>
                                {`${subtractDays(selectedPeriodOption.start_date,1, 'Do MMMM')} - ${addDays(selectedPeriodOption.end_date,1)}`}
                            </strong>
                        </p>
                    ):(<></>)}
                    <small className={`esc-ii-text-black esc-ii-font-montserrat esc-ii-text-xs`}>
                        <strong>+ {Money(selectedPeriodOptionAddOn.price)}</strong>
                    </small>
                </div>
            </div>
        ) : (
            <div className="esc-ii-flex">
                <button
                    type="button"
                    className={`esc-ii-w-12 esc-ii-h-12 esc-ii-rounded esc-ii-border`}
                    onClick={() => upsertSelectedPeriodOptionAddOns(assigned_addon)}
                    disabled={disabled}
                >
                </button>
                <div className="esc-ii-flex esc-ii-flex-col esc-ii-ml-2.5">
                    <p className={`esc-ii-font-montserrat esc-ii-text-sm`}>
                        Add {assigned_addon.addon.name}
                    </p>
                    <small className={`esc-ii-text-black esc-ii-font-montserrat esc-ii-text-xs`}>
                        + {Money(assigned_addon.price)}
                    </small>
                </div>
            </div>
        )
    });

    return (
        <Component>
            <AddOnsComponent />
        </Component>
    )

}
const OptionalAddFeatures = () => {
    const { additionalFeatures, isLoading } = useEventContext();
    const Component = ({ children }) => (
        <>
            <LabelWrapper>
                <Label>Included in your selection</Label>
            </LabelWrapper>
            <div className="esc-ii-flex esc-ii-flex-col esc-ii-space-y-2.5">
                {children}
            </div>
        </>
    );
    const SkeletonComponent = () => (
        <div className="esc-ii-flex">
            <Skeleton count={3} />
        </div>
    )

    if (isLoading) {
        return <Component><SkeletonComponent /></Component>
    }

    if (additionalFeatures.length === 0) {
        return <></>
    }
    const FeaturesComponent = () => additionalFeatures.map(feature => {
        return <div className="esc-ii-flex">
            <Icon.Tick className={`esc-ii-h-4 esc-ii-w-4`}/>
            <div className="esc-ii-flex esc-ii-flex-col esc-ii-ml-2.5">
                <p className={`esc-ii-font-montserrat esc-ii-text-sm`}>
                    {feature.title}
                </p>
            </div>
        </div>
    });

    return (
        <Component>
            <FeaturesComponent />
        </Component>
    )

}
const Duration = () => {
    const {selectedPeriod, periodOptions, selectedPeriodOption, setSelectedPeriodOption} = useEventContext();
    const Component = ({children}) => (
        <>
            <LabelWrapper>
                <Label>Duration</Label>
                <Tooltip>
                    <Subtitle text={`Duration`}/>
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-mt-3 esc-ii-font-bold esc-ii-mb-1 lg:esc-ii-text-base">For
                        our Weekend Programme
                    </p>
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-mb-3 lg:esc-ii-text-base">
                        All our weekend programmes are 1 day long and run on a Sunday.
                    </p>
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-font-bold esc-ii-mb-1 lg:esc-ii-text-base">For our Summer Experience</p>
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-mb-3 lg:esc-ii-text-base">
                        Our summer programmes are the most immersive, one-of-a-kind experiences we offer. You can attend for 1 week or 2 weeks. Choose our 2 week premium option for the ultimate, flagship experience.
                    </p>
                </Tooltip>
            </LabelWrapper>
            <Radio.Group>
                {children}
            </Radio.Group>
        </>
    )

    if (! selectedPeriod || ! Array.isArray(selectedPeriod.event_period_options) || ! Array.isArray(periodOptions)) {
        return (
            <Component>
                <div className="lg:esc-ii-hidden">
                    <Skeleton count={3} />
                </div>
                <div className="esc-ii-hidden lg:esc-ii-flex lg:esc-ii-flex-col lg:esc-ii-w-full">
                    <Skeleton containerClassName={`esc-ii-flex esc-ii-justify-between esc-ii-space-x-5`} count={3} inline={true}  />
                </div>
            </Component>
        )
    }

    let DurationOptions = () => <></>;

    if (periodOptions.length > 0) {
        DurationOptions = () => periodOptions
            .sort((a, b) => a.price > b.price ? 1 : -1)
            .filter((option) => {
                return !option.hidden;
            })
            .map((option) => (
                <Radio.Button name="duration"
                              active={selectedPeriodOption && selectedPeriodOption.value === option.value && ! option.disabled}
                              disabled={option.disabled}
                              onClick={() => setSelectedPeriodOption(option)}>
                <span className={`esc-ii-capitalize esc-ii-font-montserrat esc-ii-text-sm${selectedPeriodOption && selectedPeriodOption.value === option.value && ' esc-ii-font-bold'}`}>
                    {option.label}
                </span>
                    {option.price && (
                        <span className={`esc-ii-font-montserrat esc-ii-text-xs esc-ii-font-semibold`}>{Money(option.price)}</span>
                    )}
                    {option.disabled && (
                        <p>
                            <span className={`esc-ii-font-montserrat esc-ii-text-xs esc-ii-font-semibold`}>SOLD OUT</span>
                        </p>
                    )}
                </Radio.Button>
            ))
    }

    return (
        <Component>
            <DurationOptions />
        </Component>
    );
}

const ProgrammeSummary = () => {
    const { selectedPeriodOption } = useEventContext();

    if (!selectedPeriodOption || ! selectedPeriodOption.start_date || ! selectedPeriodOption.end_date) {
        return <></>
    }
    return (
        <>
            <p className="esc-ii-mb-2.5 esc-ii-mt-4 esc-ii-font-montserrat esc-ii-text-sm">
                Your programme dates:{' '}
                <strong className="esc-ii-text-primary">
                    {`${format(selectedPeriodOption.start_date, 'Do MMMM')} - ${format(selectedPeriodOption.end_date)}`}
                </strong>
            </p>
            <hr className="esc-ii-hidden lg:esc-ii-block" />
        </>
    )
}


const CourseType = ({ label }) => {
    const { setSelectedCourseType, selectedCourseType, courseTypes, periods, setSelectedPeriod, upsertSelectedPeriodOptionAddOns } = useEventContext();
    let Component = () => (
        <>
            <div className="lg:esc-ii-hidden">
                <Skeleton count={3} />
            </div>
            <div className="esc-ii-hidden lg:esc-ii-flex lg:esc-ii-flex-col lg:esc-ii-w-full">
                <Skeleton containerClassName={`esc-ii-flex esc-ii-justify-between esc-ii-space-x-5`} count={3} inline={true}  />
            </div>
        </>
    );
    if (courseTypes.length !== 0) {
        Component = () => (
            <>
                {
                    courseTypes.map((courseType, index) => (
                        <Radio.Button active={selectedCourseType === courseType}
                                      name="course_type"
                                      key={index}
                                      onClick={() => {
                                          setSelectedCourseType(courseType);
                                          setSelectedPeriod(periods[courseType][0] ?? {});
                                          upsertSelectedPeriodOptionAddOns([]);
                                      }}
                        >
                            <span className={`esc-ii-capitalize esc-ii-font-montserrat esc-ii-text-sm${selectedCourseType === courseType ? ' esc-ii-font-bold' : ''}`}>
                                {COURSE_TYPES[courseType]}
                            </span>
                            <span className="esc-ii-flex esc-ii-items-center">
                                {courseType === 'live_online' || <Icon.PersonPin />}
                                <span className="esc-ii-ml-1.5 esc-ii-font-montserrat esc-ii-text-xs esc-ii-capitalize">
                                    {courseType === 'live_online' || LOCATIONS[courseType]}
                                </span>
                            </span>
                        </Radio.Button>
                    ))
                }
            </>
        );
    }

    return (
        <>
            <LabelWrapper>
                <Label>{label}</Label>
                <Tooltip>
                    <Subtitle text={label} />
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-mt-3 lg:esc-ii-text-base">
                        You can choose to attend this programme either in-person or online.
                    </p>
                    <hr className="esc-ii-border esc-ii-border-[#979797]/30 esc-ii-h-px esc-ii-my-5 lg:esc-ii-my-7" />
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-font-bold esc-ii-mb-1 lg:esc-ii-text-base">In-Person Programmes</p>
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-mb-3 lg:esc-ii-text-base">
                        Our programmes are based at University College London (UCL). In addition, our Summer Experiences are also located in industry locations around London to give a realistic experience of working in that career.
                    </p>
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-font-bold esc-ii-mb-1 lg:esc-ii-text-base">Live Online Programmes</p>
                    <p className="esc-ii-font-montserrat esc-ii-text-sm esc-ii-mb-3 lg:esc-ii-text-base">
                        Our Live Online programmes take place virtually (UK time zone) and offer a highly interactive experience.
                    </p>
                </Tooltip>
            </LabelWrapper>
            <Radio.Group>
                <Component />
            </Radio.Group>
        </>
    );
}

CourseType.PropTypes = {
    label: PropTypes.string,
}


const Quantity = () => {
    const { attendeeQty, setAttendeeQty, selectedPeriodOption, canHaveMultipleAttendees } = useEventContext();

    if (! canHaveMultipleAttendees()) {
        return <></>
    }

    return (
        <Field.Quantity
            label={`Quantity`}
            qty={attendeeQty}
            min={0}
            max={selectedPeriodOption && selectedPeriodOption.quantity_available}
            onDecrement={() => setAttendeeQty((prevState) => prevState > 1 ? --prevState : prevState)}
            onIncrement={() => setAttendeeQty((prevState) => prevState < selectedPeriodOption.quantity_available ? ++prevState : prevState)}
        />
    )
}

Event.Summary = Summary;
Event.Summary.Fixed = Fixed;
Event.Total = Total;
Event.CourseType = CourseType;
Event.AvailableStartDates = AvailableStartDates;
Event.Duration = Duration;
Event.OptionalAddFeatures = OptionalAddFeatures;
Event.OptionalAddOns = OptionalAddOns;
Event.Title = Title;
Event.ProgrammeSummary = ProgrammeSummary;
Event.Quantity = Quantity;
Event.AttendeesForm = AttendeesForm;
export default Event;
